module.exports = __webpack_public_path__ + "static/media/unsw.4b0d0833.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/unsw.png
// module id = 1085
// module chunks = 0